import Vue from 'vue';
import store from '../store/store';

export default {
  pcds: {},
  promise: null,
  // 获取本地缓存的地址库，当url一致时，并且本地数据存在，才返回本地缓存数据
  getPcdsFromStorage() {
    return new Promise((resolve, reject) => {
      const storagePcdsFileUrl = window.localStorage.getItem('pcdsFileUrl');
      const storagePcdsJson = window.localStorage.getItem('pcdsJson');
      // 如果没有缓存，直接返回错误
      if (!storagePcdsJson) {
        reject();
        return;
      }
      try {
        // 判断数据是否正常，不正常则返回错误
        const parseStoragePcdsJson = JSON.parse(storagePcdsJson);
        if (!parseStoragePcdsJson || !parseStoragePcdsJson[86]) {
          reject();
          return;
        }
      } catch (e) {
        reject(e);
        return;
      }
      // json存在，需判断URL一致时才使用缓存
      store.dispatch('config/getSysConfig', {}, { root: true })
        .then((data) => {
          const nowPcdsFileUrl = data.addr_download_url;
          if (storagePcdsFileUrl === nowPcdsFileUrl) {
            // 当UIR一致的时候，才使用缓存
            resolve(JSON.parse(storagePcdsJson));
            return;
          }
          reject();
        }).catch(() => {
          reject();
        });
    });
  },

  getPcdsFromServer() {
    return this.promise = new Promise((resolve, reject) => {
      this.getPcdsFromStorage()
        .then((data) => {
          // 缓存中有数据，直接使用缓存数据
          this.pcds = data;
          resolve(data);
        })
        .catch(() => {
          // 没有缓存，重新请求地址库
          store.dispatch('config/getSysConfig', {}, { root: true })
            .then((sysConfig) => {
              // 获取地址库地址，然后请求该文件
              Vue.http.get(sysConfig.addr_download_url)
                .then((res) => {
                  if (res.body && res.body[86]) {
                    // 把获取来的地址存到浏览器缓存中
                    window.localStorage.setItem('pcdsFileUrl', sysConfig.addr_download_url);
                    window.localStorage.setItem('pcdsJson', JSON.stringify(res.body));
                    this.pcds = res.body;
                    resolve(res.body);
                  }
                  reject();
                })
                .catch(() => {
                  reject();
                });
            });
        });
    });
  },

  getPcd() {
    if (this.promise) {
      return this.promise;
    }
    return this.getPcdsFromServer();
  },
};



// WEBPACK FOOTER //
// ./src/services/pcd-service.js